export default "__VITE_ASSET__fad55d94__"